/**
 * Download file based on provided link and do fake 'click' by current user.
 */
export function downloadFileByLinkElement(href: string): void {
  const linkElement: HTMLAnchorElement = document.createElement('a');

  linkElement.href = href;
  linkElement.download = 'download';

  window.document.body.appendChild(linkElement);
  linkElement.click();
  window.document.body.removeChild(linkElement);
}

/**
 * Download file based on provided name/blob and do fake 'click' by current user.
 */
export function downloadFileByBlob(name: string, blob: Blob): void {
  const linkElement: HTMLAnchorElement = document.createElement('a');

  linkElement.href = URL.createObjectURL(blob);
  linkElement.download = name;

  window.document.body.appendChild(linkElement);
  linkElement.click();
  window.document.body.removeChild(linkElement);
}

/**
 * Download file based on user platform Mac or PC provided link and do fake 'click' by current user.
 */
export function downloadFileByPlatform(macLink: string, pcLink: string): void {
  // todo: Probably should use parse device utils or move this one into them (isMacOS/isAppleOS or so).
  const downloadLink = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) ? macLink : pcLink;

  downloadFileByLinkElement(downloadLink);
}
